<template>
  <v-card
    flat
    outlined
    rounded
    elevation="1"
    class="sidebar catalog d-flex flex-column fill-height"
  >
    <v-toolbar
      dark
      color="transparent"
      dense
      flat
      class="catalog-header"
    >
      <v-toolbar-title class="pink--text text--darken-3">
        Catalog
      </v-toolbar-title>
      <!-- disable access to shortcuts
      <v-btn icon @click="$emit('collapse')">
        <v-icon>mdi-menu</v-icon>
      </v-btn>
      -->
      <v-spacer />
      <!-- CatalogLoader -->
      <catalog-loader
        v-if="showLoader"
        ref="loader"
        @load="$emit('catalog:load', $event)"
      />
      <v-chip
        label
        dark
        outlined
        color="blue-grey lighten-5"
        class="catalog-status"
      >
        <v-icon
          :color="statusIcon.color"
          v-text="statusIcon.name"
        />
      </v-chip>
    </v-toolbar>

    <v-row no-gutters>
      <v-col>
        <v-tabs
          v-model="tab"
          color="pink darken-3"
          grow
          height="36"
          light
          slider-size="1"
          class="mt-1"
        >
          <v-tab
            href="#tree"
            class="tab-header text-subtitle-1"
          >
            <v-icon
              left
              small
            >
              mdi-file-tree
            </v-icon>tree
          </v-tab>
          <v-tab
            href="#issues"
            class="tab-header text-subtitle-1"
          >
            <span>
              <v-icon
                left
                small
              >mdi-alert-circle-outline</v-icon>issues
            </span>
          </v-tab>
        </v-tabs>
      </v-col>
    </v-row>
    <v-row
      no-gutters
      class="fill-height overflow-y-auto ma-2"
    >
      <v-col>
        <v-tabs-items v-model="tab">
          <v-tab-item value="tree">
            <v-text-field
              v-if="catalog.imported"
              v-model="search"
              label="Filter..."
              hide-details
              clearable
              clear-icon="mdi-close-circle-outline"
              dense
              class="pa-2 mb-2"
              background-color="transparent"
              color="pink darken-3"
            />

            <!-- CatalogTree -->
            <catalog-tree
              ref="tree"
              :catalog="catalog"
              :search="search"
            />
          </v-tab-item>
          <v-tab-item value="issues">
            <!-- CatalogIssues -->
            <catalog-issues
              ref="issues"
              :issues="catalog.issues"
            />
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'

import CatalogLoader from '@/components/catalog/loader'
import CatalogTree from '@/components/catalog/tree'
import CatalogIssues from '@/components/catalog/issues'
import { getEntryStyle } from '@/components/utils'

import Catalog from '@/models/catalog'

export default {
	name: 'Sidebar',

	components: {
		CatalogLoader,
		CatalogTree,
		CatalogIssues,
	},
	props: {
		catalog: {
			type: Catalog,
			required: true,
		},
		showLoader: {
			type: Boolean,
			default: true,
		},
		showTree: {
			type: Boolean,
			default: true,
		},
	},
	data: () => ({
		tab: null,
		showRecordDialog: false,
		search: null,
	}),
	computed: {
		statusIcon() {
			switch (this.catalog.status) {
				case 'success':
					return {
						name: 'mdi-check-bold',
						color: 'success',
					}
				case 'warning':
					return {
						name: 'mdi-alert-outline',
						color: 'warning',
					}
				case 'error':
					return {
						name: 'mdi-alert-circle',
						color: 'error',
					}
				default:
					// 'idle'
					return {
						name: 'mdi-help',
						color: 'blue-grey lighten-4',
					}
			}
		},
		issuesStats: function() {
			if (this.catalog.errors.length > 0)
				return {
					type: 'error',
					color: 'error',
					count: this.catalog.errors.length,
				}
			else if (this.catalog.warnings.length > 0)
				return {
					type: 'warning',
					color: 'warning',
					count: this.catalog.warnings.length,
				}
			else
				return {
					type: null,
				}
		},
	},
	mounted: function() {
		this.loader = this.$refs.loader
		this.tree = this.$refs.tree
		this.issues = this.$refs.issues

    // Run test
    // for( let i = 0; i < 200; i++ ) {
    //   this.addJoker('event')
    // }    
	},
	methods: {
		...mapActions('journal', ['addJoker']),
		getEntryStyle,
	},
}
</script>

<style lang="scss">
.sidebar {
	.tab-header {
		text-transform: initial !important; // do not uppercase
	}
	.catalog-header > .v-toolbar__content {
		border-bottom: 2px solid #ad1457; // pink darken-3
		.catalog-status {
			opacity: 0.75;
		}
	}
}
</style>
